module.exports = __webpack_public_path__ + "assets/img/ic-message-blue.0863a560.svg";